import { render, staticRenderFns } from "./BrandReports.vue?vue&type=template&id=70130fa3&scoped=true&"
import script from "./BrandReports.vue?vue&type=script&lang=js&"
export * from "./BrandReports.vue?vue&type=script&lang=js&"
import style0 from "./BrandReports.vue?vue&type=style&index=0&id=70130fa3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70130fa3",
  null
  
)

export default component.exports